import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "./index";
import { setClarityTag } from "./clarity";
import { isProviderApp, isAdminApp } from "../config/theme";
import { PAGE_VIEWED } from "./events";

/**
 * Hook that automatically tracks page views on route changes.
 * Place this once inside the Router context (e.g., in AppRouter).
 */
export function usePageTracking() {
  const location = useLocation();
  const prevPath = useRef(null);

  useEffect(() => {
    // Skip duplicate tracking for same path
    if (location.pathname === prevPath.current) return;
    prevPath.current = location.pathname;

    const appType = isAdminApp()
      ? "admin"
      : isProviderApp()
        ? "provider"
        : "homeowner";

    analytics.track(PAGE_VIEWED, {
      path: location.pathname,
      app_type: appType,
    });

    setClarityTag("page_path", location.pathname);
  }, [location.pathname]);
}
